import { render, staticRenderFns } from "./StaffsListing.vue?vue&type=template&id=0ea6c1b4&scoped=true&"
import script from "./StaffsListing.vue?vue&type=script&lang=js&"
export * from "./StaffsListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea6c1b4",
  null
  
)

export default component.exports